import React from 'react';

import DeliveryTable from '../components/delivery-page/index';

class DeliveryPage extends React.Component{
	render(){
		return (
			<div style={{ margin: 16 }}>
                <DeliveryTable />
			</div>
		)
	}

}


export default DeliveryPage;


// WEBPACK FOOTER //
// ./src/containers/delivery-page.js